import { Component, inject, OnInit, signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  DOCUMENT_SECTION_OPTIONS,
  DocumentBoSectionType,
} from '@lib/models/documents/document-consultant-section';
import { DocumentService } from '@lib/services/documents/documents.service';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiAutocomplete } from 'omnium-ui/form-field';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiLoading } from 'omnium-ui/loading';
import { OuiSnackbarService } from 'omnium-ui/snackbar';

@Component({
  selector: 'app-update-doc-section-dialog',
  standalone: true,
  imports: [OuiDialogModule, OuiButton, OuiIconModule, OuiAutocomplete, OuiLoading],
  templateUrl: './update-doc-section-dialog.component.html',
  styleUrl: './update-doc-section-dialog.component.scss',
})
export class UpdateDocSectionDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<UpdateDocSectionDialogComponent>);
  private readonly documentService = inject(DocumentService);
  private readonly snackbarService = inject(OuiSnackbarService);

  readonly data = inject(MAT_DIALOG_DATA);

  readonly isLoading = signal<boolean>(false);
  readonly sectionControl = new FormControl<DocumentBoSectionType>(
    this.data.documentSection,
    [Validators.required]
  );
  readonly sectionOption = DOCUMENT_SECTION_OPTIONS;

  async confirm() {
    try {
      if (
        this.sectionControl.value &&
        this.sectionControl.value !== this.data.documentSection
      ) {
        this.isLoading.set(true);
        await this.documentService.updateDocumentSection(
          this.data.documentId,
          this.sectionControl.value
        );
        this.isLoading.set(false);
      }

      this.snackbarService.open('La section du document a bien été changée', 'success');
      this.dialogRef.close(true);
    } catch (er) {
      this.isLoading.set(false);
      this.snackbarService.open(
        'Une erreur est survenue durant la changement de section',
        'error'
      );
      this.dialogRef.close(false);
    }
  }
}
